import { Attachment } from "../model/Attachment";

export class AttachmentHelper {
    public static isAttachmentPresent(attachment: Attachment): boolean {
        return attachment && attachment.attachmentLocationData !== null && attachment.attachmentLocationData != undefined;
    }
}
